// src/composables/useInstallPrompt.js
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { Capacitor } from '@capacitor/core'

export function useInstallPrompt() {
  const deferredPrompt = ref(null)
  const isWeb = Capacitor.getPlatform() === 'web'

  function onBeforeInstall(e) {
    e.preventDefault()
    deferredPrompt.value = e
  }

  async function promptInstall() {
    if (!deferredPrompt.value) return { outcome: 'dismissed' }
    const { outcome } = await deferredPrompt.value.prompt()
    deferredPrompt.value = null
    return { outcome }
  }

  onMounted(() => {
    if (!isWeb) return // no PWA prompt en nativo Capacitor
    window.addEventListener('beforeinstallprompt', onBeforeInstall)
  })

  onBeforeUnmount(() => {
    if (!isWeb) return
    window.removeEventListener('beforeinstallprompt', onBeforeInstall)
  })

  return { deferredPrompt, promptInstall, isWeb }
}
